import { useState } from "react";
import TotpWidget from "../components/ui/TotpWidget.jsx";
import Topbar from "../components/layout/Topbar.jsx";
import { useAuth } from "../context/AuthContext.jsx";

export default function ProfilePage() {
  const { user } = useAuth(); const isAdmin = true;
  const [activeTab, setActiveTab] = useState("profile");
  const [notifPrefs, setNotifPrefs] = useState({ email:true, inapp:true, digest:"immediate" });
  const [saved, setSaved] = useState(false);

  const save = () => { setSaved(true); setTimeout(() => setSaved(false), 2000); };

  return (
    <>
      <Topbar title="Mon" subtitle="profil" admin={isAdmin} />
      <div className="page-body" style={{ maxWidth:720 }}>

        {/* Avatar header */}
        <div className="itm-card anim-fade-up" style={{ marginBottom:20, padding:24 }}>
          <div style={{ display:"flex", alignItems:"center", gap:20 }}>
            <div style={{ width:72, height:72, borderRadius:18, background:"linear-gradient(135deg,var(--accent3),var(--accent))", display:"flex", alignItems:"center", justifyContent:"center", fontSize:26, fontWeight:800, color:"#fff", fontFamily:"Syne,sans-serif", flexShrink:0 }}>
              {user?.firstName?.[0]}{user?.lastName?.[0]}
            </div>
            <div>
              <div style={{ fontFamily:"Syne,sans-serif", fontSize:20, fontWeight:800, color:"var(--text-1)", marginBottom:4 }}>{user?.fullName}</div>
              <div style={{ fontSize:13, color:"var(--text-2)", marginBottom:6 }}>{user?.email}</div>
              <span className={`badge-status ${isAdmin ? "bs-active" : "bs-open"}`}>{isAdmin ? "Administrateur" : "Utilisateur client"}</span>
            </div>
          </div>
        </div>

        {/* Onglets */}
        <div className="itm-tabs">
          {[{id:"profile",label:"Informations"},{id:"security",label:"Sécurité"},{id:"notifications",label:"Notifications"}].map(t=>(
            <div key={t.id} className={`itm-tab ${activeTab===t.id?"active":""}`} onClick={()=>setActiveTab(t.id)}>{t.label}</div>
          ))}
        </div>

        {/* Tab Profil */}
        {activeTab === "profile" && (
          <div className="itm-card anim-fade-in">
            <div className="form-row">
              <div className="form-group">
                <label className="itm-label">Prénom</label>
                <input className="itm-input" defaultValue={user?.firstName} />
              </div>
              <div className="form-group">
                <label className="itm-label">Nom</label>
                <input className="itm-input" defaultValue={user?.lastName} />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="itm-label">Email</label>
                <input className="itm-input" type="email" defaultValue={user?.email} />
              </div>
              <div className="form-group">
                <label className="itm-label">Téléphone</label>
                <input className="itm-input" placeholder="+33 6 00 00 00 00" />
              </div>
            </div>
            <div style={{ display:"flex", justifyContent:"flex-end", marginTop:4 }}>
              <button className="btn-itm btn-itm-primary" onClick={save}>
                {saved ? <><i className="bi bi-check2" /> Enregistré !</> : <><i className="bi bi-floppy" /> Enregistrer</>}
              </button>
            </div>
          </div>
        )}

        {/* Tab Sécurité */}
        {activeTab === "security" && (
          <div className="itm-card anim-fade-in">
            <div className="card-title" style={{ marginBottom:16 }}>Changer le mot de passe</div>
            <div className="form-group">
              <label className="itm-label">Mot de passe actuel</label>
              <input className="itm-input" type="password" placeholder="••••••••" />
            </div>
            <div className="form-group">
              <label className="itm-label">Nouveau mot de passe</label>
              <input className="itm-input" type="password" placeholder="Minimum 8 caractères" />
            </div>
            <div className="form-group">
              <label className="itm-label">Confirmer le nouveau mot de passe</label>
              <input className="itm-input" type="password" placeholder="••••••••" />
            </div>
            <div style={{ padding:"10px 14px", background:"var(--accent-dim)", borderRadius:10, fontSize:12, color:"var(--accent)", marginBottom:16 }}>
              <i className="bi bi-shield-check me-2" />
              Règles : min. 8 caractères, 1 majuscule, 1 chiffre, 1 caractère spécial.
            </div>
            <div style={{ display:"flex", justifyContent:"flex-end" }}>
              <button className="btn-itm btn-itm-primary"><i className="bi bi-lock" /> Changer le mot de passe</button>
            </div>
          </div>
        )}

        {/* Tab Sécurité — section 2FA */}
        {activeTab === "security" && (
          <div className="itm-card anim-fade-in" style={{ marginTop:16 }}>
            <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
              <div style={{ width:36, height:36, borderRadius:10, background:"var(--accent-dim)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                <i className="bi bi-shield-lock-fill" style={{ color:"var(--accent)", fontSize:16 }}/>
              </div>
              <div>
                <div className="card-title" style={{ marginBottom:0 }}>Double authentification (2FA)</div>
                <div style={{ fontSize:12, color:"var(--text-3)", marginTop:2 }}>
                  Ajoutez une couche de sécurité avec une application TOTP (Google Authenticator, Authy…)
                </div>
              </div>
            </div>
            <div style={{ maxWidth:480 }}>
              <TotpWidget
                credentialId={null}
                hasTotpSecret={false}
                onUpdate={() => {}}
                readOnly={false}
                adminMode={true}
              />
            </div>
          </div>
        )}

        {/* Tab Notifications */}
        {activeTab === "notifications" && (
          <div className="itm-card anim-fade-in">
            <div className="card-title" style={{ marginBottom:16 }}>Préférences de notification</div>
            {[
              { key:"email",  label:"Notifications par email", desc:"Recevoir des emails lors des changements de statut" },
              { key:"inapp",  label:"Notifications in-app",    desc:"Afficher les notifications dans l'interface" },
            ].map(p => (
              <div key={p.key} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 0", borderBottom:"1px solid var(--border)" }}>
                <div>
                  <div style={{ fontSize:13, fontWeight:500, color:"var(--text-1)" }}>{p.label}</div>
                  <div style={{ fontSize:12, color:"var(--text-3)" }}>{p.desc}</div>
                </div>
                <div style={{
                  width:44, height:24, borderRadius:12, cursor:"pointer", transition:"background .2s",
                  background: notifPrefs[p.key] ? "var(--accent)" : "var(--navy-soft)",
                  border:"1px solid var(--border)", position:"relative"
                }} onClick={() => setNotifPrefs(prev => ({...prev, [p.key]: !prev[p.key]}))}>
                  <div style={{
                    width:18, height:18, borderRadius:"50%", background:"#fff",
                    position:"absolute", top:2, transition:"left .2s",
                    left: notifPrefs[p.key] ? 22 : 2
                  }} />
                </div>
              </div>
            ))}
            <div style={{ marginTop:16 }}>
              <label className="itm-label">Fréquence des emails</label>
              <select className="itm-select" style={{ width:"100%" }} value={notifPrefs.digest} onChange={e => setNotifPrefs(p => ({...p, digest:e.target.value}))}>
                <option value="immediate">Immédiat (à chaque événement)</option>
                <option value="daily">Résumé quotidien</option>
                <option value="weekly">Résumé hebdomadaire</option>
              </select>
            </div>
            <div style={{ display:"flex", justifyContent:"flex-end", marginTop:16 }}>
              <button className="btn-itm btn-itm-primary" onClick={save}>
                {saved ? <><i className="bi bi-check2" /> Enregistré !</> : <><i className="bi bi-floppy" /> Enregistrer</>}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}